const text = (value, max) => typeof value === 'string' ? value.trim().slice(0, max) : '';
const finite = value => Number.isFinite(value) ? value : null;

// Vote documents are written by anyone holding the link; never trust their shape.
export const sanitizeVotePlaces = places => (Array.isArray(places) ? places : []).slice(0, 5).map(place => {
  const lat = finite(place?.lat);
  const lng = finite(place?.lng);
  return {
    place_id: text(place?.placeId, 200),
    name: text(place?.name, 120),
    vicinity: text(place?.vicinity, 200),
    cuisineLabel: text(place?.cuisineLabel, 20) || '餐飲',
    walkMinutes: finite(place?.walkMinutes),
    rating: finite(place?.rating),
    user_ratings_total: finite(place?.reviewCount) || 0,
    price_level: Number.isInteger(place?.priceLevel) ? place.priceLevel : null,
    geometry: lat != null && lng != null ? { location: { lat, lng } } : null
  };
}).filter((place, index, all) => place.place_id && place.name && all.findIndex(item => item.place_id === place.place_id) === index);

export function tallyVotes(places, ballots) {
  const ids = new Set(places.map(place => place.place_id));
  const voters = (Array.isArray(ballots) ? ballots : []).map(ballot => ({
    id: ballot.id,
    name: text(ballot.name, 20),
    picks: Object.fromEntries(Object.entries(ballot.picks && typeof ballot.picks === 'object' ? ballot.picks : {})
      .filter(([placeId, pick]) => ids.has(placeId) && (pick === 'yes' || pick === 'no')))
  })).filter(voter => Object.keys(voter.picks).length);
  const rows = places.map((place, index) => {
    const yes = voters.filter(voter => voter.picks[place.place_id] === 'yes');
    const no = voters.filter(voter => voter.picks[place.place_id] === 'no');
    return { place, index, yes: yes.length, no: no.length, yesNames: yes.map(voter => voter.name) };
  });
  const [leader] = [...rows].filter(row => row.yes > 0).sort((a, b) => b.yes - a.yes || a.no - b.no || a.index - b.index);
  return {
    rows,
    voters: voters.length,
    leader: leader || null,
    // Agreement means everyone who voted wants it and nobody vetoed it.
    agreed: Boolean(leader && voters.length >= 2 && leader.yes === voters.length && leader.no === 0)
  };
}
